module.exports = __webpack_public_path__ + "static/calorex-header-greenfoam-tb-6d7e7df4233f82ef2eef4265910944bb.jpg";